// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PlaceOrderApiModel from "../api-model/PlaceOrderApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function apiModelToEntity(data) {
  return {
          order_crn: data.order_crn
        };
}

function execute(json) {
  var data = DeccoUtils$Catalyst.resolveResult(PlaceOrderApiModel.t_decode(json), "PlcaOrderEnityMapper.res");
  return {
          order_crn: data.order_crn
        };
}

export {
  apiModelToEntity ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
